import * as React from 'react';

import { MED_DATE_ONLY_DISPLAY, formatDateTimeDisplay } from 'js/utils/DateTimeUtils';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

import type { GetUpcomingCourseStatesQuery_DegreeLearnerCourseStatesV1Resource_get_notStarted as NotStartedCourse } from '../UpcomingCourses/__generated__/getUpcomingCourseStatesQuery';
import type { GetEnrollableSessionsQuery_OnDemandSessionsV1Resource_nextEnrollableSessionsByUserAndCourse_elements as EnrollableSession } from './__generated__/GetEnrollableSessionsQuery';

type EnrollmentReminderBannerDescriptionWithSessionInfoProps = {
  courseName?: string;
  sessionStartDate?: number;
};

// Component for single course with enrollable sessions
export const EnrollmentReminderBannerDescriptionWithSessionInfo = ({
  courseName,
  sessionStartDate,
}: EnrollmentReminderBannerDescriptionWithSessionInfoProps) => {
  return (
    <React.Fragment>
      {courseName && sessionStartDate ? (
        <Typography2 component="p" variant="bodyPrimary">
          {_t('The next available start date for #{courseName} begins on #{sessionStartDate}.', {
            courseName,
            sessionStartDate: formatDateTimeDisplay(sessionStartDate, MED_DATE_ONLY_DISPLAY),
          })}
        </Typography2>
      ) : (
        <Typography2 component="p" variant="bodyPrimary">
          {/* Fallback for when fetching the data for the single course has been unsuccessful */}
          {_t(
            'The next available start date for 1 course is coming up. Check out your enrollment options to begin learning.'
          )}
        </Typography2>
      )}
    </React.Fragment>
  );
};

type EnrollmentReminderBannerDescriptionProps = {
  enrollableCourses: NotStartedCourse[];
  singleEnrollableCourse?: EnrollableSession | null;
};
const EnrollmentReminderBannerDescription = ({
  enrollableCourses,
  singleEnrollableCourse,
}: EnrollmentReminderBannerDescriptionProps) => {
  const hasMultipleEnrollableCourses = enrollableCourses.length > 1;

  return (
    <React.Fragment>
      {hasMultipleEnrollableCourses ? (
        <Typography2 component="p" variant="bodyPrimary">
          {_t(
            'The next available start dates for #{numOfCourses} courses are coming up. Check out your enrollment options to begin learning.',
            { numOfCourses: enrollableCourses.length }
          )}
        </Typography2>
      ) : (
        <EnrollmentReminderBannerDescriptionWithSessionInfo
          courseName={enrollableCourses[0]?.name}
          sessionStartDate={singleEnrollableCourse?.startedAt}
        />
      )}
    </React.Fragment>
  );
};

export default EnrollmentReminderBannerDescription;
